import { FC } from 'react';
import Modal from 'antd/es/modal/Modal';
import { useTranslation } from 'react-i18next';
import SvgIcon from '@/components/SvgIcon';
import styles from './index.module.scss';

interface ContactSuccessModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ContactSuccessModal: FC<ContactSuccessModalProps> = ({ open, onCancel, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onCancel={onCancel} closeIcon={<SvgIcon name="x-black" size={16} />} footer={null} centered width={400} className={styles.contactSuccessModal}>
      <div className={styles.content}>
        {/* Success Icon */}
        <div className={styles.iconWrapper}>
          <SvgIcon name="successful" size={76} />
        </div>

        {/* Title */}
        <h3 className={styles.title}>{t('contactUs.successModal.title')}</h3>

        {/* Description */}
        <p className={styles.description}>{t('contactUs.successModal.description')}</p>

        {/* Confirm Button */}
        <button className={styles.confirmButton} onClick={onConfirm} type="button">
          {t('contactUs.successModal.confirm')}
        </button>
      </div>
    </Modal>
  );
};

export default ContactSuccessModal;
